module.exports = __webpack_public_path__ + "static/media/buroPlatformWhite@2x.b4892ce5.png";